import React from 'react';
import { injectIntl, WrappedComponentProps } from 'react-intl';
import * as R from 'ramda';

import { Container } from 'components/shared/container/Container.styled';
import { SectionFlattenProps } from '../section/Section.props';
import { translate } from 'shared/utils/translate';
import * as Styled from './USP.styled';

const getSize = (count: number) => {
  if (count < 2) return 'xlg';
  if (count === 2) return 'lg';
  return 'md';
};

const USPSection = ({
  components,
  theme = {},
  intl,
}: WrappedComponentProps & SectionFlattenProps) => {
  const color = theme?.color || '';
  const backgroundColor = theme?.backgroundColor || '';

  if (!components) return null;

  return (
    <Styled.Wrapper backgroundColor={backgroundColor}>
      <Container>
        <Styled.FlexibleLayout>
          {components.map(component => (
            <Styled.ComponentWrapper
              key={component.id}
              size={getSize(components.length)}
            >
              {component.imageUrl && (
                <Styled.ComponentIcon src={component.imageUrl} />
              )}
              {(component.title || component.body) && (
                <div>
                  {component.title && (
                    <Styled.HeadingWrapper>
                      <Styled.Heading color={color}>
                        {translate({ intl, id: component.title })}
                      </Styled.Heading>
                    </Styled.HeadingWrapper>
                  )}
                  {component.body && (
                    <Styled.Paragraph color={color}>
                      {translate({ intl, id: component.body })}
                    </Styled.Paragraph>
                  )}
                </div>
              )}
            </Styled.ComponentWrapper>
          ))}
        </Styled.FlexibleLayout>
      </Container>
    </Styled.Wrapper>
  );
};

export default injectIntl(USPSection);
